import { combineReducers } from 'redux';

import type { Action } from 'modules/global/generic.types';
import type { Nullable } from 'modules/global/typing/common/common';
import {
  ASSIGN_BRANDS_TO_GUIDELINE_SUCCESS,
  ASSIGN_MODAL_FAILURE,
  ASSIGN_MODAL_READY,
  CLOSE_ASSIGN_MODAL,
  OPEN_ASSIGN_MODAL,
} from 'modules/guidelines/actionTypes';
import type { OpenAssignmentModalAction, OpenAssignmentModalPayload } from 'modules/guidelines/types/actions';
import { createReducer } from 'utils/ReduxUtils';

const params = createReducer<Partial<OpenAssignmentModalPayload>>({}, {
  [OPEN_ASSIGN_MODAL]: (_, { payload }: OpenAssignmentModalAction) => payload,
  [CLOSE_ASSIGN_MODAL]: () => ({}),
});

const isOpen = createReducer<boolean>(false, {
  [OPEN_ASSIGN_MODAL]: () => true,
  [CLOSE_ASSIGN_MODAL]: () => false,
  [ASSIGN_BRANDS_TO_GUIDELINE_SUCCESS]: () => false,
});

const isReady = createReducer<boolean>(false, {
  [OPEN_ASSIGN_MODAL]: () => false,
  [ASSIGN_MODAL_READY]: () => true,
  [ASSIGN_MODAL_FAILURE]: () => true,
});

// The failure payload is whatever `afterOpenAssignmentModal` threw (Axios error from a
// rethrown auto-generated failure, or any runtime error) — consumers only null-check it.
const errorSlice = createReducer<Nullable<unknown>>(null, {
  [OPEN_ASSIGN_MODAL]: () => null,
  [ASSIGN_MODAL_FAILURE]: (_, { payload }: Action<unknown>) => payload,
});

export default combineReducers({
  params,
  isOpen,
  isReady,
  error: errorSlice,
});
